// @flow
import { camelize, snakeify } from '@rover/utilities/object-utilities';
import parseApiErrors from '@rover/utilities/parseApiErrors';
import { t } from '@lingui/macro';
import { getAxiosInstance } from '@rover/utilities/axiosUtils';
import addressFactory from '@rover/react-lib/factories/addressFactory';
import type { Address } from '@rover/react-lib/types/Address';
import type { ExpressParams } from '@rover/react-lib/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';
import reportError from '@rover/utilities/reportError';
import APIError from './APIError';

const buildAddressApiUrl = (personOpk: string) => fullApiUrl(`people/${personOpk}/home/`);

export const get = async (personOpk: string, expressParams: ?ExpressParams): Promise<Address> => {
  const ai = getAxiosInstance(expressParams);
  try {
    const response = await ai.get(buildAddressApiUrl(personOpk));
    return camelize(response.data);
  } catch (error) {
    const { response } = error;
    if (response && response.status === 404) {
      return addressFactory();
    }
    const errors = parseApiErrors(response);
    const message = errors.length ? errors.pop() : t`There was an error fetching address.`;
    const apiError = new APIError(message, response.status);
    reportError(apiError);
    throw apiError;
  }
};

export const post = async (
  personOpk: string,
  address: Address,
  expressParams: ?ExpressParams
): Promise<void> => {
  const ai = getAxiosInstance(expressParams);
  try {
    const data = snakeify(address);
    await ai.post(buildAddressApiUrl(personOpk), data);
  } catch (error) {
    const { response } = error;
    const errors = parseApiErrors(response);
    const message = errors.length ? errors.pop() : t`There was an error saving address.`;
    const apiError = new APIError(message, response.status);
    reportError(apiError);
    throw apiError;
  }
};



// WEBPACK FOOTER //
// ../react-lib/src/apis/address.api.js